import { type RouteConfig } from 'vue-router'
import ranking from './pages/ranking/index.vue'
import Home from '@/pages/home/index.vue'
import Search from '@/pages/search/index.vue'
import History from '@/pages/history/index.vue'
import Member from '@/pages/member/index.vue'
import ContactUs from '@/pages/contact-us/index.vue'
import Setting from '@/pages/setting/index.vue'
import Pay from '@/pages/pay/index.vue'
import Paying from '@/pages/paying/index.vue'
import Consume from '@/pages/consume/index.vue'
import Recharge from '@/pages/recharge/index.vue'
import Book from '@/pages/book/index.vue'
import Chapter from '@/pages/chapter/index.vue'
import ChapterScroll from '@/pages/chapter-scroll/index.vue'
import Welfare from '@/pages/welfare/index.vue'
import Collection from '@/pages/collection/index.vue'
import Error from '@/pages/error/index.vue'
import NotFound from '@/pages/404/index.vue'
import Subscribe from '@/pages/subscribe/index.vue'
import Login from '@/pages/login/index.vue'
import PopupLogin from '@/pages/popup-login/index.vue'
import Tags from '@/pages/tags/index.vue'
import Recommended from '@/pages/recommend/index.vue'
import { brand } from '@/config/brands'

const routes: Array<RouteConfig> = [
  { path: '/login', name: 'login', component: Login, meta: { title: 'Login', requiresAuth: false } },
  { path: '/popup-login', name: 'popup-login', component: PopupLogin, meta: { title: 'Login', requiresAuth: false } },
  { path: '/', name: 'home', component: Home, meta: { title: 'Novel', keepAlive: true }, props: true },
  { path: '/search', name: 'search', component: Search, meta: { title: 'Search' } },
  { path: '/history', name: 'history', component: History, meta: { title: 'History' } },
  { path: '/member', name: 'member', component: Member, meta: { title: 'Profile', requiresUserInfo: true } },
  { path: '/contact-us', name: 'contact-us', component: ContactUs, meta: { title: 'Contact us' } },
  { path: '/setting', name: 'setting', component: Setting, meta: { title: 'Setting', requiresUserInfo: true } },
  { path: '/recharge', name: 'recharge', component: Recharge, meta: { title: 'Transaction History' } },
  { path: '/consume', name: 'consume', component: Consume, meta: { title: 'Chapters UnLocked' } },
  { path: '/pay', name: 'pay', component: Pay, meta: { title: 'Store', requiresUserInfo: true } },
  { path: '/content/:contentId', name: 'book', component: Book, meta: { title: 'Detail' }, props: true },
  { path: '/content/:contentId/:chapterId', name: 'chapter', component: Chapter, meta: { title: 'Chapter Detail', requiresUserInfo: true }, props: true },
  { path: '/content/:contentId/scroll/:chapterId', name: 'chapter-scroll', component: ChapterScroll, meta: { title: 'Chapter Detail', requiresUserInfo: true }, props: true },
  { path: '/welfare', name: 'welfare', component: Welfare, meta: { title: 'Rewards' } },
  { path: '/collection/:columnId', name: 'collection', component: Collection, meta: { title: 'Collection' }, props: true },
  { path: '/paying', name: 'paying', component: Paying, meta: { title: 'Payment' }, props: route => ({ code: route.query.code, productId: route.query.productId }) },
  { path: '/subscribe', name: 'subscribe', component: Subscribe, meta: { title: 'Membership' }, props: true },
  { path: '/tags', name: 'tags', component: Tags, meta: { title: 'Tags' } },
  { path: '/ranking/:columnId', name: 'ranking', component: ranking, meta: { title: 'Ranking' }, props: true },
  { path: '/recommend/:contentId', name: 'recommend', component: Recommended, meta: { title: 'Recommend' }, props: true },
  { path: '/500', name: 'error', component: Error, meta: { title: 'Error', requiresAuth: false }, props: route => ({ level: route.query.level }) },
  ...(brand === 'novelyn'
    ? [{ path: '/404', name: 'notFound', component: NotFound, meta: { title: '404', requiresAuth: false } }]
    : []),
  {
    path: '*',
    name: brand === 'novelyn' ? 'notFoundFallback' : 'notFound',
    alias: brand === 'novelyn' ? undefined : '/404',
    component: NotFound,
    meta: { title: '404', requiresAuth: false },
  },
]

export default routes
